module.exports = __webpack_public_path__ + "img/co-investing-1.26b14b5f.jpg";